import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import DemoPlayer from 'containers/SupplierProfile/components/DemoPlayer'
import { toColor } from 'utils'

const VoiceTalent = ({ unavailable = false, initials, display_name, userid, demos, description, age, languages, addedAt, collections = [], favorite = false, onFavorite, selected, onSelect }) => {

  const oneWeekAgo = new Date()
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)

  const highlight = addedAt > (oneWeekAgo.getTime() / 1000) 

  return (
    <li className={`${selected ? 'shadow-lg bg-gray-100' : ''} ${unavailable ? 'opacity-50' : ''} relative hover:bg-gray-200`}>
      { unavailable ? (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform -mr-2 -mt-2 bg-yellow-400 rounded-full shadow">
          Unavailable
        </span>
      ) : highlight ? (
        <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform -mr-2 -mt-2 bg-primary rounded-full shadow">
          New
        </span>
      ) : null }

      <div className="col-span-1 flex shadow-sm rounded-sm group hover:bg-gray-50 h-16">
        <div className={`shrink-0 flex items-center justify-center h-16 w-16 text-white text-sm font-medium rounded-l-sm ${toColor(userid)} cursor-pointer hover:opacity-75`} onClick={onSelect}>
          { selected ? (
            <Icon icon="check" />
          ) : initials }
        </div>
        <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 rounded-r-sm truncate">
          <div className="flex-1 px-4 py-2 text-sm truncate">
            <span className="text-gray-900 font-medium hover:text-gray-600">{ display_name }</span>

            <a
              className="text-gray-500 ml-2 hover:text-primary cursor-pointer"
              target="_blank"
              href={`https://www.voicearchive.com/en/voicefinder/search/${userid}`}
            >
              { userid }
            </a>

            <p className="text-gray-600 truncate space-x-2 text-xs" title={[description, age, languages.map(({name}) => name).join(', ')].filter(Boolean).join(', ')}>
              { collections.includes('voicestar') &&
                <span>
                  <Icon icon={['fas', 'star']} className="mr-1 text-xs text-tertiary" title="Recommended"  />
                </span>
              }
              { collections.includes('ai_ambassador') &&
                <span>
                  <Icon icon={['fas', 'robot']} className="mr-1 text-xs text-tertiary" title="AI voice clone"  />
                </span>
              }

              { description &&
                <span>
                  <Icon icon={['fal', 'user']} className="mr-1 text-xs" />
                  { description }
                </span>
              }

              { age &&
                <span>
                  <Icon icon={['fal', 'clock']} className="mr-1 text-xs" />
                  { age } y/o
                </span>
              }

              { !!languages.length &&
                <span>
                  <Icon icon={['fal', 'flag']} className="mr-1 text-xs" />
                  { languages.map(({name}) => name).join(', ') }
                </span>
              }
            </p>
          </div>
          <div className="shrink-0 pr-2 flex justify-start">
            <button onClick={onFavorite}>
              <Icon
                icon={[favorite ? 'fas' : 'fal', 'heart']}
                className={`fa-fw group-hover:${toColor(userid, 'text')} ${favorite ? toColor(userid, 'text') : 'text-gray-200'} hover:text-primary-darker cursor-pointer`}
              />
            </button>

            { demos && demos.length > 0 &&
                <DemoPlayer
                  src={demos[0].cdn_url}
                  className="w-auto mx-2"
                  iconClassName={`fa-fw text-gray-200 group-hover:${toColor(userid, 'text')} hover:text-primary-darker cursor-pointer`}
                  downloadable
                />
            }
          </div>
        </div>
      </div>
    </li>
  )
}

export default VoiceTalent
